<template>
    <div>
        <div class="tabs is-boxed">
            <ul>
                <router-link :to="{ name: 'client-games-general' }" active-class="is-active" tag="li" exact>
                    <a>General</a>
                </router-link>
                <router-link
                    :to="{ name: 'client-games-list', params: { provider: 'redpipe' } }"
                    active-class="is-active"
                    tag="li"
                    :class="{ 'is-active': provider == 'redpipe' }"
                >
                    <a>RedPipe</a>
                </router-link>
                <router-link :to="{ name: 'client-games-list', params: { provider: 'flg' } }" active-class="is-active" tag="li">
                    <a>FLG</a>
                </router-link>
                <router-link :to="{ name: 'client-games-list', params: { provider: 'hdraces' } }" active-class="is-active" tag="li">
                    <a>HdRaces</a>
                </router-link>
                <router-link :to="{ name: 'client-games-list', params: { provider: 'bk' } }" active-class="is-active" tag="li">
                    <a>Bk</a>
                </router-link>
                <router-link :to="{ name: 'client-games-list', params: { provider: 'mascot' } }" active-class="is-active" tag="li">
                    <a>Mascot</a>
                </router-link>
                <router-link :to="{ name: 'client-games-list', params: { provider: 'aviatrix' } }" active-class="is-active" tag="li">
                    <a>Aviatrix</a>
                </router-link>
                <router-link :to="{ name: 'client-games-list', params: { provider: 'galaxsys' } }" active-class="is-active" tag="li">
                    <a>Galaxsys</a>
                </router-link>
                <router-link :to="{ name: 'client-games-list', params: { provider: 'smartsoft' } }" active-class="is-active" tag="li">
                    <a>SmartSoft</a>
                </router-link>
                <router-link :to="{ name: 'client-games-list', params: { provider: 'vegas' } }" active-class="is-active" tag="li">
                    <a>Vegas</a>
                </router-link>
                <router-link :to="{ name: 'client-games-list', params: { provider: 'boldplay' } }" active-class="is-active" tag="li">
                    <a>Boldplay</a>
                </router-link>
                <router-link
                    :to="{ name: 'client-games-list', params: { provider: 'doublechancelotto' } }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>DoubleChanceLotto</a>
                </router-link>
                <router-link :to="{ name: 'client-games-list', params: { provider: 'baas' } }" active-class="is-active" tag="li">
                    <a>Baas</a>
                </router-link>
                <router-link :to="{ name: 'client-games-lists' }" active-class="is-active" tag="li">
                    <a>Games lists</a>
                </router-link>
                <router-link
                    :to="{ name: 'client-games-aggregator', params: { aggregator: 'betconstruct' } }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>BetConstruct</a>
                </router-link>
            </ul>
        </div>

        <router-view />
    </div>
</template>

<script>
import breadcrumbsService from '../../../../services/breadcrumbs.service';

export default {
    name: 'client-games',
    computed: {
        provider() {
            return this.$route.params.provider;
        },
        aggregator() {
            return this.$route.params.aggregator;
        }
    },
    mounted() {
        breadcrumbsService.dynamic.set({ key: 'game-provider', func: () => this.provider });
        breadcrumbsService.dynamic.set({ key: 'game-aggregator', func: () => this.aggregator });
    }
};
</script>



// WEBPACK FOOTER //
// front/src/components/clients/client/games/index.vue